// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tandc_container__n1Zgq {
    /* margin-top: 3em; */
    margin: auto ;
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding-top: 5em;
    -webkit-user-select: none;
            user-select: none;
    background-color: rgb(255, 255, 255);

}
.tandc_upperContainer__rZpkb {
    padding: 10px;
}
.tandc_upperContainerLink__JIkMo{
    margin-top: 1em;
    padding: 1em 3em;
    display: flex;
    flex-direction: row;
}

.tandc_flexContainer__rAf7z{
    background-color: rgb(255, 255, 255);
    /* padding: 3em; */
    padding-bottom: 2.5em;
    display: flex;
    justify-content: center;
    padding: 0em 3em;
    gap: 3em;
}

.tandc_flex__r9hjS{
    flex: 1 1;
}

.tandc_upperContainerLink__JIkMo h3{
    color: #06BCF1;
    padding-left: 10px;
}

.tandc_lowerContainer__6y5zH h3{
    color: #06BCF1;
}
.tandc_innerLowerContainer__0iHG2 div{
    color: #06BCF1;
    font-size: 24px;
    font-weight:600;
    margin-top: 1em;
}

.tandc_innerLowerContainer__0iHG2{list-style-type: none;
}

.tandc_linkStyle__hc-z9{
    text-decoration: none;
    color: rgb(103, 103, 103);
    font-size: 1.2em;
}

.tandc_linkStyle__hc-z9:hover{
    color: #06BCF1;
}

/* Css for upper container */
.tandc_upperContainer__rZpkb {
    background-color: rgb(255, 255, 255);
    /* padding: 3em; */
    padding-bottom: 1em;
    display: flex;
    justify-content: center;
}

.tandc_upperContainer__rZpkb h1{
    font-size: 2.5em;
    font-weight: 600;
}

.tandc_flexContainer__rAf7z h1{
    font-size: 3em;
    font-weight: 900;
}



/* css for middle container */

.tandc_middleContainer__3UKBT{
    background-color: rgb(255, 255, 255);
    /* text-align: center; */
    display: flex;
    flex-direction: column;
    gap: 2em;
    margin-bottom: 45px;
}

.tandc_middleContainer__3UKBT h1 {
    text-align: left;
    font-size: 1.5em;
    font-weight: bold;
}


/* css for lower container*/

.tandc_lowerContainer__6y5zH {
    margin-top: 1em;
}


.tandc_innerLowerContainer__0iHG2 h2 {
    font-size: 20px;
    font-weight: 700;
    color:#06BCF1;
}

.tandc_innerLowerContainer__0iHG2 b{
    font-weight: bolder;
}

.tandc_nestedOrder__z2lQv {
    padding-top: 0.5em;
    font-size: 1em;
    line-height: 1.4em;
    text-align: justify;
    text-justify: inter-word;
}

.tandc_innerLowerContainer__0iHG2 ol{
    list-style-type: none;
}

/* css for code of conduct*/

.tandc_conclusion__4l\\+kh{
    margin-bottom: 1em;
}
.tandc_conclusion__4l\\+kh h2{
    font-size: larger;
    font-weight: 500;
}

.tandc_conclusion__4l\\+kh p{
    font-size: 1.1em;
    line-height: 1.4em;
    text-align: justify;
    text-justify: inter-word;
}

/* css for policy */

.tandc_headerContainer__34puD{
    text-align: center;
    padding: 0 5em;
}`, "",{"version":3,"sources":["webpack://./src/core/css/tandc.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,oCAAoC;;AAExC;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA,kCAAqB,qBAAqB;AAC1C;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;;;AAIA,6BAA6B;;AAE7B;IACI,oCAAoC;IACpC,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;;AAGA,2BAA2B;;AAE3B;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2BAA2B;;AAE3B;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA,mBAAmB;;AAEnB;IACI,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".container {\n    /* margin-top: 3em; */\n    margin: auto ;\n    display: flex;\n    flex-direction: column;\n    gap: 1em;\n    padding-top: 5em;\n    user-select: none;\n    background-color: rgb(255, 255, 255);\n\n}\n.upperContainer {\n    padding: 10px;\n}\n.upperContainerLink{\n    margin-top: 1em;\n    padding: 1em 3em;\n    display: flex;\n    flex-direction: row;\n}\n\n.flexContainer{\n    background-color: rgb(255, 255, 255);\n    /* padding: 3em; */\n    padding-bottom: 2.5em;\n    display: flex;\n    justify-content: center;\n    padding: 0em 3em;\n    gap: 3em;\n}\n\n.flex{\n    flex: 1;\n}\n\n.upperContainerLink h3{\n    color: #06BCF1;\n    padding-left: 10px;\n}\n\n.lowerContainer h3{\n    color: #06BCF1;\n}\n.innerLowerContainer div{\n    color: #06BCF1;\n    font-size: 24px;\n    font-weight:600;\n    margin-top: 1em;\n}\n\n.innerLowerContainer{list-style-type: none;\n}\n\n.linkStyle{\n    text-decoration: none;\n    color: rgb(103, 103, 103);\n    font-size: 1.2em;\n}\n\n.linkStyle:hover{\n    color: #06BCF1;\n}\n\n/* Css for upper container */\n.upperContainer {\n    background-color: rgb(255, 255, 255);\n    /* padding: 3em; */\n    padding-bottom: 1em;\n    display: flex;\n    justify-content: center;\n}\n\n.upperContainer h1{\n    font-size: 2.5em;\n    font-weight: 600;\n}\n\n.flexContainer h1{\n    font-size: 3em;\n    font-weight: 900;\n}\n\n\n\n/* css for middle container */\n\n.middleContainer{\n    background-color: rgb(255, 255, 255);\n    /* text-align: center; */\n    display: flex;\n    flex-direction: column;\n    gap: 2em;\n    margin-bottom: 45px;\n}\n\n.middleContainer h1 {\n    text-align: left;\n    font-size: 1.5em;\n    font-weight: bold;\n}\n\n\n/* css for lower container*/\n\n.lowerContainer {\n    margin-top: 1em;\n}\n\n\n.innerLowerContainer h2 {\n    font-size: 20px;\n    font-weight: 700;\n    color:#06BCF1;\n}\n\n.innerLowerContainer b{\n    font-weight: bolder;\n}\n\n.nestedOrder {\n    padding-top: 0.5em;\n    font-size: 1em;\n    line-height: 1.4em;\n    text-align: justify;\n    text-justify: inter-word;\n}\n\n.innerLowerContainer ol{\n    list-style-type: none;\n}\n\n/* css for code of conduct*/\n\n.conclusion{\n    margin-bottom: 1em;\n}\n.conclusion h2{\n    font-size: larger;\n    font-weight: 500;\n}\n\n.conclusion p{\n    font-size: 1.1em;\n    line-height: 1.4em;\n    text-align: justify;\n    text-justify: inter-word;\n}\n\n/* css for policy */\n\n.headerContainer{\n    text-align: center;\n    padding: 0 5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tandc_container__n1Zgq`,
	"upperContainer": `tandc_upperContainer__rZpkb`,
	"upperContainerLink": `tandc_upperContainerLink__JIkMo`,
	"flexContainer": `tandc_flexContainer__rAf7z`,
	"flex": `tandc_flex__r9hjS`,
	"lowerContainer": `tandc_lowerContainer__6y5zH`,
	"innerLowerContainer": `tandc_innerLowerContainer__0iHG2`,
	"linkStyle": `tandc_linkStyle__hc-z9`,
	"middleContainer": `tandc_middleContainer__3UKBT`,
	"nestedOrder": `tandc_nestedOrder__z2lQv`,
	"conclusion": `tandc_conclusion__4l+kh`,
	"headerContainer": `tandc_headerContainer__34puD`
};
export default ___CSS_LOADER_EXPORT___;
